'use client';

import a__default, { forwardRef } from "react";
import b from "../lib/IconBase.js";
import t$1 from "../defs/WarningOctagon.js";
var i = Object.defineProperty, c = Object.defineProperties;
var f = Object.getOwnPropertyDescriptors;
var t = Object.getOwnPropertySymbols;
var g = Object.prototype.hasOwnProperty, p = Object.prototype.propertyIsEnumerable;
var e = (r, o, a) => o in r ? i(r, o, { enumerable: true, configurable: true, writable: true, value: a }) : r[o] = a, n = (r, o) => {
  for (var a in o || (o = {}))
    g.call(o, a) && e(r, a, o[a]);
  if (t)
    for (var a of t(o))
      p.call(o, a) && e(r, a, o[a]);
  return r;
}, m = (r, o) => c(r, f(o));
const I = forwardRef((r, o) => /* @__PURE__ */ a__default.createElement(b, m(n({ ref: o }, r), { weights: t$1 })));
I.displayName = "WarningOctagon";
export {
  I as WarningOctagon
};
